import React from 'react';
import { useRouter } from 'next/router';
import WalletIcon from '@images/activate/ic_wallet.svg';
import Discord from '@images/activate/ic_discord.svg';
import DiscordBlackIcon from '@images/activate/ic_discord_black.svg';
import TestDriveBanner from '@images/activate/test_drive_banner.svg';

const ActivateLoginComponent = () => {
	const router = useRouter();
	return (
		<div className="flex flex-col h-screen px-10 pt-10 pb-[3rem] bg-[#FAFAFA] overflow-y-auto">
			<div className="flex-none">
				<div className="p-4">
					<div className="flex justify-between">
						<div className="flex items-center">
							<div className="text-lg text-black font-700 mr-[2rem]">Frodobots</div>
							<span className="text-gray-700">{'Step 1 of 4'}</span>
						</div>

						<div className="flex items-center text-black text-bold">Log in to continue.</div>
					</div>
				</div>
			</div>

			<div className="flex-grow flex flex-col items-center text-center justify-center mb-[1rem]">
				<div className="p-4">
					<h3 className="text-black mb-16">Get ready to activate!</h3>
				</div>

				<div className="flex flex-col justify-between bg-[#EFEFEF] p-10 mr-5 rounded-2xl max-w-[26rem]">
					<h4 className="text-left p-6">Steps:</h4>
					<div className="flex bg-white p-6 mb-[1rem] rounded-xl">
						<div className="p-6 mr-[1rem]">
							<img
								src={DiscordBlackIcon}
								alt="img-fluid"
							/>
						</div>
						<div className="flex flex-col text-left">
							<h6 className="text-xs mt-5">Log into your Discord account.</h6>
							<div className="text-gray-600 mb-3">Your Discord account is linked to locate your FrodoBot.</div>
						</div>
					</div>
					<div className="flex bg-white p-4 mb-[1rem] rounded-xl">
						<div className="p-6 mr-[1rem]">
							<img
								src={WalletIcon}
								alt="img-fluid"
							/>
						</div>
						<div className="flex flex-col text-left">
							<h6 className="text-xs mt-5">Confirm your NFT and Wallet.</h6>
							<div className="text-gray-600 mb-3">
								Your FrodoBot comes with a unique NFT and your account has a wallet for FBT.
							</div>
						</div>
					</div>
					<div className="flex bg-white rounded-xl">
						<img
							src={TestDriveBanner}
							alt="img-fluid"
						/>
					</div>
				</div>
			</div>

			<div className="flex justify-center">
				<div className="p-4">
					<button
						className="bg-[#5865F2] text-white p-6 min-w-[12rem] rounded-xl"
						onClick={() => router.push('/activate-login')}
					>
						<img
							className="mr-4"
							src={Discord}
							alt="img-fluid"
						/>
						Log in via Discord
					</button>
				</div>
			</div>
		</div>
	);
};

export default ActivateLoginComponent;
